module.exports = __webpack_public_path__ + "img/mi-image.8780bc6b.svg";